import {Flex, Text, VStack} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {useFormDate} from 'hooks';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

interface Props {
  t: (term: TranslationKeys) => string;
  short_uuid: string;
  delivered: string;
}

export const OrderSummary: FC<Props> = ({t, short_uuid, delivered}) => {
  const {date} = useFormDate(delivered, 'HH:mm / dd.MM.yyyy');

  return (
    <IconBlock icon="/icons/purchase.svg">
      <Flex flexDirection={['column', 'row']} justifyContent="space-between" alignItems="center">
        <VStack spacing="5px" alignItems="flex-start">
          <Text fontWeight="700" fontSize="16px">
            {t('ORDER_DELIVERED')} {date}
          </Text>
          {/*<Text fontWeight="500">{t('COURIER_NAME')}: Veceslav Andreev</Text>*/}
          <Text fontWeight="500">
            {t('ORDER_NUMBER')}:
            <Text as="span" ml="5px" fontWeight="bold">
              {short_uuid}
            </Text>
          </Text>
        </VStack>
        {/*<Button variant="outline" mt={['10px', '0']} w={['full', 'auto']}>*/}
        {/*  {t('HELP')}*/}
        {/*</Button>*/}
      </Flex>
    </IconBlock>
  );
};
